import React from 'react';
import { View, Pressable, Platform, StyleSheet } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';

interface UniversalRatingProps {
  value: number;
  maxRating?: number;
  size?: number;
  readOnly?: boolean;
  onRatingChange?: (rating: number) => void;
  activeColor?: string;
  inactiveColor?: string;
}

const UniversalRating: React.FC<UniversalRatingProps> = ({
  value = 0,
  maxRating = 5,
  size = 20,
  readOnly = true,
  onRatingChange,
  activeColor = '#FFD700',
  inactiveColor = '#CCCCCC',
}) => {
  const handlePress = (rating: number) => {
    if (!readOnly && onRatingChange) {
      onRatingChange(rating);
    }
  };

  const renderStar = (index: number) => {
    const starValue = index + 1;
    const isFullStar = value >= starValue;
    const isHalfStar = value > index && value < starValue;

    return (
      <Pressable
        key={index}
        onPress={() => handlePress(starValue)}
        disabled={readOnly}
        style={[
          styles.starContainer,
          Platform.OS === 'web' && !readOnly && styles.starContainerWeb,
        ]}
      >
        {isHalfStar ? (
          <View style={styles.halfStarContainer}>
            <FontAwesome name="star" size={size} color={inactiveColor} />
            <View style={[styles.halfStarOverlay, { width: size * (value - index) }]}>
              <FontAwesome name="star" size={size} color={activeColor} />
            </View>
          </View>
        ) : (
          <FontAwesome
            name={isFullStar ? 'star' : 'star-o'}
            size={size}
            color={isFullStar ? activeColor : inactiveColor}
          />
        )}
      </Pressable>
    );
  };

  return (
    <View style={styles.container}>
      {[...Array(maxRating)].map((_, index) => renderStar(index))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  starContainer: {
    padding: 2,
  },
  starContainerWeb: {
    cursor: 'pointer' as any,
  },
  halfStarContainer: {
    position: 'relative',
  },
  halfStarOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    overflow: 'hidden',
  },
});

export default UniversalRating;

